export default __webpack_public_path__ + "static/wevideo_logo-d405cc767c4e4272285b131ee470a361.svg";